const MakeRequest = require("../Helpers/MakeRequest");
module.exports = async (setIsAuthenticated) => {
    try {
        await MakeRequest({}, 'auth/logout', 'post');
        setIsAuthenticated(false);
        window.location.reload();
    } catch (e) {
        console.error("Logout error:", e);
    }
};